module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMy42MTYiIGhlaWdodD0iMTMuNTAzIiB2aWV3Qm94PSIwIDAgMjMuNjE2IDEzLjUwMyI+DQogIDxwYXRoIGlkPSJJY29uX2lvbmljLWlvcy1hcnJvdy1kb3duIiBkYXRhLW5hbWU9Ikljb24gaW9uaWMtaW9zLWFycm93LWRvd24iIGQ9Ik0xMS44MTMsOS40MzIsMjAuNzQyLjVhMS42ODEsMS42ODEsMCwwLDEsMi4zODQsMCwxLjcsMS43LDAsMCwxLDAsMi4zOTFMMTMuMDA4LDEzLjAxMWExLjY4NSwxLjY4NSwwLDAsMS0yLjMyNy4wNDlMLjQ5MiwyLjg5M0ExLjY4OCwxLjY4OCwwLDAsMSwyLjg3Ni41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjMuNjE2IDEzLjUwMykgcm90YXRlKDE4MCkiIGZpbGw9IiM1NTUiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/arrow-down.svg
// module id = 1769
// module chunks = 1